import algoliasearch from 'algoliasearch';

const client =  algoliasearch('4N0ABFZGJB', '4aad0eefd81b52532b66608ecba05efd');

export default client;